import React, { useEffect } from 'react'
import Popup from '../Popup'
import './preview.css'
import { handleNewEventLog } from '../../../lib/utils/events'

const PreviewPopup = (props) => {
  useEffect(() => {
    if (props.isPreviewFromThreeDotsMenu) {
      handleNewEventLog(
        'chapter_editor',
        'novels_chapter_preview_viewed',
        {
          route: window.location.pathname + window.location.search,
          module_name: 'chapter_editor_three_dots_menu',
          entity_id: props.chapter_id || 'Null',
          entity_type: 'chapter',
        },
        props.user,
        props.novelDetails
      )
    }
  }, [props.show])

  return <Popup className="preview-chapter" {...props} />
}
export default PreviewPopup
